export const getIsFree = (plan: Plan) => {
  return plan?.plan_type === 'free';
};
